import React, { useEffect } from "react";
import { Container, Typography, Box, Divider } from "@mui/material";

const TermsOfService = () => {
  useEffect(() => {
    document.title = "Terms";
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Box>
        <Typography variant="h4" fontWeight="bold" gutterBottom color="primary">
          Terms of Service
        </Typography>
        <Typography variant="caption" color="text.secondary" gutterBottom>
          Last Updated: April 21, 2025
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography paragraph>
          By placing an order on www.cakeyhand.com, visiting our store, or
          interacting with any of our services, you agree to be bound by these
          Terms of Service.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          1. Order Acceptance
        </Typography>
        <Typography paragraph>
          Orders are subject to availability and acceptance. We reserve the
          right to cancel or refuse any order for any reason, including
          suspected fraud, incomplete details, or operational constraints.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          2. Payments
        </Typography>
        <Typography paragraph>
          All payments must be completed at checkout unless otherwise specified.
          In-store payments must be confirmed by a receipt number at the time of
          order submission.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          3. Cancellations & Changes
        </Typography>
        <Typography paragraph>
          Refunds or credits are issued in cases of confirmed product issues,
          service failures, or cancellations per our policy window. Each case is
          reviewed individually. Orders that are picked up late or mishandled
          after pickup are not eligible.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          4. Refunds and Credits
        </Typography>
        <Typography paragraph>
          Refunds or store credits may be issued in cases of confirmed product
          issues or service failures. Every request is manually reviewed by our
          team to ensure fairness and transparency.
        </Typography>
        <Typography paragraph>
          For full details on eligibility, what’s covered, and how to submit a
          request, please refer to our{" "}
          <Box component="span" sx={{ display: "inline" }}>
            <a
              href="/refund-policy"
              style={{ color: "#FD7762", textDecoration: "underline" }}>
              Refund & Credit Policy
            </a>
            .
          </Box>
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          5. Product Handling
        </Typography>
        <Typography paragraph>
          Cakes and pastries are delicate items. Proper storage (e.g.,
          refrigeration) is the customer’s responsibility. We are not liable for
          damages after the product has left our store or upon successful
          delivery.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          6. Customizations
        </Typography>
        <Typography paragraph>
          All custom orders are made based on selected options. We do our best
          to interpret customer expectations, but design interpretation may
          vary. No refunds are issued for aesthetic preferences unless the
          product deviates significantly from the description.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          7. Allergy Notice
        </Typography>
        <Typography paragraph>
          Although we offer allergy-friendly products, all items are produced in
          a shared facility where nuts, dairy, gluten, and other allergens are
          present. We cannot guarantee an allergen-free environment.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          8. Communication
        </Typography>
        <Typography paragraph>
          By using our services, you agree to receive communications about your
          order, account, and updates to policies.
        </Typography>

        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }}>
          9. Changes to Terms
        </Typography>
        <Typography paragraph>
          We may update these Terms of Service at any time. Continued use of the
          site or placing orders after updates constitutes agreement to the
          revised terms.
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="body2" color="text.secondary">
          If you have questions or concerns about our Terms of Service, please
          contact us at contact@cakeyhand.com.
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsOfService;
